export function lpad(value: unknown, length: number, fill: string = '0'): string {
  let valueStr = String(value);

  while (valueStr.length < length) {
    valueStr = fill + valueStr;
  }

  return valueStr;
}
